import styled from 'styled-components';

export const Caixa = styled.section`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  /* Espaço no fim: o botão flutuante do WhatsApp não cobre o "Continuar". */
  padding: 0 16px 112px;
  box-sizing: border-box;
  font-family: 'Lato', sans-serif;
  color: var(--cinza-100);

  * { box-sizing: border-box; }
`;

export const Passos = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0;

  button {
    border: 1px solid var(--cinza-30);
    background: var(--white);
    color: var(--cinza-70);
    border-radius: 999px;
    padding: 6px 12px;
    font: inherit;
    font-size: 13px;
    min-height: 32px;
    cursor: default;
  }
  button.feito { color: var(--neutro-40); border-color: var(--neutro-20); cursor: pointer; }
  button.atual { background: var(--neutro-30); border-color: var(--neutro-30); color: var(--white); font-weight: 700; }
`;

export const Cartao = styled.div`
  background: var(--white);
  border: 1px solid var(--cinza-30);
  border-radius: 12px;
  padding: 28px;

  h2 { margin: 0 0 6px; font-size: 22px; font-weight: 900; }
  .lead { margin: 0 0 20px; color: var(--cinza-80); font-size: 16px; line-height: 1.5; }
  ul { margin: 8px 0 16px; padding-left: 22px; list-style: disc; }
  li { margin: 4px 0; font-size: 15px; line-height: 1.4; }

  @media (max-width: 640px) { padding: 20px 16px; }
`;

export const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px 20px;

  .cheio { grid-column: 1 / -1; }

  @media (max-width: 640px) { grid-template-columns: minmax(0, 1fr); }
`;

export const Secao = styled.div`
  grid-column: 1 / -1;
  margin-top: 10px;
  padding-top: 18px;
  border-top: 1px solid var(--cinza-30);

  &.primeira { margin-top: 0; padding-top: 0; border-top: 0; }
  h3 { margin: 0; font-size: 17px; font-weight: 900; }
  p { margin: 4px 0 0; color: var(--cinza-70); font-size: 14px; }
`;

export const Campo = styled.div`
  .rot { display: block; font-weight: 700; font-size: 14px; margin-bottom: 6px; }
  .opc { font-weight: 400; color: var(--cinza-70); }
  .ajuda { margin: 6px 0 0; color: var(--cinza-70); font-size: 13px; line-height: 1.4; }
  .erro { margin: 6px 0 0; color: var(--erro-50); font-size: 13px; font-weight: 700; }
  .selo { display: inline-block; margin-left: 8px; background: var(--principal-10); color: var(--neutro-40); border-radius: 999px; padding: 2px 8px; font-size: 12px; font-weight: 700; }

  input[type='text'], input[type='date'], input[type='time'], input[type='email'], select {
    width: 100%;
    min-height: 46px;
    border: 1px solid var(--cinza-40);
    border-radius: 8px;
    padding: 10px 12px;
    font: inherit;
    font-size: 16px;
    color: var(--cinza-100);
    background: var(--white);
  }
  input:focus, select:focus { outline: 2px solid var(--neutro-30); outline-offset: 1px; }
  &.com-erro input, &.com-erro select { border-color: var(--erro-50); }
  &.ia input, &.ia select { background: #F4FFF6; border-color: var(--neutro-20); }

  fieldset { border: 0; margin: 0; padding: 0; min-width: 0; }
  legend { padding: 0; }
  .pills { display: flex; flex-wrap: wrap; gap: 8px; }
  .pills button {
    min-height: 44px; padding: 10px 16px; border: 1px solid var(--cinza-40); border-radius: 8px;
    background: var(--white); font: inherit; font-size: 15px; color: var(--cinza-100); cursor: pointer;
  }
  .pills button.on { border-color: var(--neutro-30); background: var(--principal-10); color: var(--neutro-40); font-weight: 700; box-shadow: inset 0 0 0 1px var(--neutro-30); }

  .check { display: flex; gap: 10px; align-items: center; min-height: 44px; font-size: 15px; cursor: pointer; }
  .check input { width: 20px; height: 20px; accent-color: var(--neutro-30); }
`;

export const Upload = styled.div`
  grid-column: 1 / -1;
  border: 2px dashed var(--cinza-50);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  background: var(--cinza-10);

  &.ok { border-style: solid; border-color: var(--neutro-20); background: #F4FFF6; }
  .txt { flex: 1 1 280px; min-width: 0; }
  h4 { margin: 0; font-size: 16px; font-weight: 900; }
  p { margin: 4px 0 0; color: var(--cinza-80); font-size: 14px; line-height: 1.45; }
  .erro { color: var(--erro-50); font-weight: 700; }
  input[type='file'] { position: absolute; width: 1px; height: 1px; opacity: 0; overflow: hidden; }
`;

export const Aviso = styled.div`
  grid-column: 1 / -1;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 14px;
  line-height: 1.45;
  background: var(--cinza-20);
  color: var(--cinza-90);

  &.atencao { background: var(--atencao-10); border: 1px solid var(--atencao-40); color: var(--cinza-80); }
  &.ok { background: var(--principal-10); color: var(--neutro-40); }
`;

export const Botao = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 10px 20px;
  border-radius: 8px;
  font: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  background: var(--neutro-30);
  color: var(--white);

  &:disabled { opacity: 0.6; cursor: default; }
  &.sec { background: var(--white); color: var(--neutro-30); border-color: var(--neutro-30); }
  &.link { background: transparent; color: var(--cinza-80); text-decoration: underline; padding: 10px 8px; }
`;

export const Rodape = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid var(--cinza-30);

  .faltam { flex-basis: 100%; margin: 0; background: var(--erro-10); color: var(--secundaria-dark); border-radius: 8px; padding: 10px 14px; font-weight: 700; font-size: 14px; }
`;

export const Revisao = styled.div`
  border: 1px solid var(--cinza-30);
  border-radius: 10px;
  margin-bottom: 14px;

  .cab { display: flex; justify-content: space-between; align-items: center; gap: 8px; padding: 12px 16px; border-bottom: 1px solid var(--cinza-30); background: var(--cinza-10); border-radius: 10px 10px 0 0; }
  .cab h3 { margin: 0; font-size: 16px; font-weight: 900; }
  .linha { display: grid; grid-template-columns: minmax(140px, 240px) minmax(0, 1fr); gap: 12px; padding: 10px 16px; border-bottom: 1px solid var(--cinza-20); font-size: 15px; }
  .linha:last-child { border-bottom: 0; }
  .r { color: var(--cinza-70); }
  .subtitulo { padding: 12px 16px 4px; font-size: 13px; font-weight: 900; text-transform: uppercase; letter-spacing: .04em; color: var(--neutro-40); }

  @media (max-width: 640px) { .linha { grid-template-columns: minmax(0, 1fr); gap: 2px; } }
`;

export const Emails = styled.div`
  margin: 20px 0 0;
  padding: 20px;
  border: 1px solid var(--cinza-30);
  border-radius: 12px;
  background: var(--cinza-10);

  .linha-email { display: flex; flex-wrap: wrap; gap: 8px; }
  .linha-email input { flex: 1 1 240px; min-width: 0; }
  .item { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin: 10px 0 0; font-size: 15px; }
`;

export const Fim = styled.div`
  text-align: center;
  padding: 24px 0;

  h2 { font-size: 26px; }
  a { display: inline-flex; margin-top: 12px; }
  .acoes { display: flex; flex-wrap: wrap; justify-content: center; gap: 12px; margin-top: 20px; }
  .acoes a { margin-top: 0; }
`;
